<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading === true"/>
                <div id="row">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title">Eras</h5>
                            <div class="row text-center">
                                <div class="col">
                                    <label class="switch">
                                        <input v-model="addTab" type="checkbox" id="togBtn" @change="resetAlerts()">
                                        <div class="slider round">
                                            <span style="font-size: 15px;" class="off">Edit</span>
                                            <span style="font-size: 15px;" class="on">Add New</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-if="addTab == false">
                                <div class="row mb-5">
                                    <div class="col-3">
                                        <select class="form-control custom-dropdown" v-model="selectedEra" @change="resetAlerts()">
                                            <option disabled selected value="">Pick an Era</option>
                                            <option v-for="era in eras" :key="era.id" :value="era">{{ era.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="selectedEra" class="row mb-4">
                                    <div class="col-4">
                                        <label>Name:</label>
                                        <input v-model="selectedEra.name" type="text" class="form-control"/>
                                    </div>
                                </div>

                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                
                                <button v-if="selectedEra" class="btn btn-primary mt-5" @click="updateEra()">Update Era</button>
                                <button v-if="selectedEra" class="btn btn-primary btn-danger mt-5 float-right" @click="deleteEra()"><i class="text-white fa fa-trash"></i> Delete Era</button>
                            </div>

                            <div v-else>
                                <div class="row mb-4">
                                    <div class="col-4">
                                        <label>* Name:</label>
                                        <input v-model="newEra.name" type="text" class="form-control"/>
                                    </div>
                                </div>

                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                
                                <button class="btn btn-primary mt-5" @click="createNew()">Create Era</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
import Eras from '../controllers/eras.controller';

export default {
    name: 'Eras',
    data: function() {
        return {
            addTab: false,
            loading: false,
            eras: [],
            selectedEra: '',
            newEra: {},
            errorMessage: '',
            successMessage: ''
        }
    },
    beforeMount: async function() {
        this.loading = true;
        this.eras = await Eras.getAll();
        this.loading = false;
    },
    methods: {
        resetAlerts() {
            this.successMessage = '';
            this.errorMessage = '';
        },

        async createNew() {
            if (!this.newEra.name) {
                this.errorMessage = 'Please make sure all mandatory fields are filled';
                this.successMessage = '';
                return;
            }
            this.loading = true;

            let added = await Eras.createNew(this.newEra.name);

            if (added == true) {
                this.errorMessage = '';
                this.successMessage = 'Era created successfully';
                // Refresh the eras list
                this.eras = await Eras.getAll();
                // Reset the add form
                this.newEra = {};
            } else if (added.error) {
                this.errorMessage = added.error;
                this.successMessage = '';
            } else {
                this.errorMessage = 'Something went wrong while creating your era';
                this.successMessage = '';
            }

            this.loading = false;
        },

        async updateEra() {
            if (!this.selectedEra.id) {
                this.errorMessage = 'Please pick a valid era';
                this.successMessage = '';
                return;
            }
            this.loading = true;

            let updated = await Eras.update(this.selectedEra.id, this.selectedEra.name);

            if (updated == true) {
                this.errorMessage = '';
                this.successMessage = 'Era updated successfully';
                // Refresh the eras list
                this.eras = await Eras.getAll();
                // Reset the add form
                this.selectedEra = '';

            } else if (updated.error) {
                this.errorMessage = updated.error;
                this.successMessage = '';
            } else {
                this.errorMessage = 'Something went wrong while updating your era';
                this.successMessage = '';
            }

            this.loading = false;
        },

        async deleteEra() {
            if (!this.selectedEra.id) {
                this.errorMessage = 'Please pick a valid era';
                this.successMessage = '';
                return;
            }
            this.loading = true;

            let deleted = await Eras.delete(this.selectedEra.id);

            if (deleted == true) {
                this.errorMessage = '';
                this.successMessage = 'Era deleted successfully';
                // Refresh the eras list
                this.eras = await Eras.getAll();

                // Remove the era info from the form 
                this.selectedEra = '';
            } else if (deleted.error) {
                this.errorMessage = deleted.error;
                this.successMessage = '';
            } else {
                this.errorMessage = 'Something went wrong while deleting your era';
                this.successMessage = '';
            }

            this.loading = false;
        }
    }
}
</script>